import {z} from '@hono/zod-openapi';

/**
 * Monetary value as the database returns it: a JS number or an exact decimal string.
 * Deliberately not `z.coerce.number()` — coercion turns `null` and `''` into `0`, which
 * silently understates a report instead of surfacing a broken contract.
 */
export const amount = z
  .union([z.number(), z.string().regex(/^-?\d+$|^-?\d+\.\d+$/)])
  .transform(Number)
  .pipe(z.number().finite());
